<template>
  <div @change="validateSection">
    <header>
      <h3>{{sectionHeader}}</h3>
      <div class="smd-spacer"></div>
    </header>

    <div class="content">

      <!--- Removed on version 7
      <div class="form__row--x">
        <label>Does patient have gynecological conditons?</label>
        <smd-segment type="pill"
                     v-model="isGyne"
                     :items="$options.booleanChoices"
                     :disabled="isClose"/>
      </div>
      --->

      <template v-if="isGyne">
        <div class="form__row--x">
          <label>Please indicate the final diagnosis. The diagnosis must be confirmed by histopath if applicable. If final Diagnosis not found in the drop down click others and type your final diagnosis.</label>
          <smd-select v-model="gynecologicalDiagnosisModel"
                      :hide-tags="true"
                      :hide-selected="true"
                      :options="mutiSelectLookup"
                      :style="highlightIfError('gynecologicalDiagnosis')"
                      v-if="!isClose"
                      @open="onSelectOpen"
                      @search-change="onSearchChange"/>


        </div>
        <template v-if="showDiagnosis">
          <div class="data-entry-3" >
            <label>Category</label>
            <label>Condition</label>
            <label>Stage/Other Details</label>
          </div>

          <div class="data-entry-3" v-for="(value, key) in gynecologicalDiagnosis" :key="key">
            <p><strong>{{ value.categoryId | decodeGyneCategory  }}</strong></p>
            <p>
              {{ key | decodeGyneCondition }}
            </p>
            <p v-if="value.conditionId !== 999999">

              <select v-model="value.gyneStage"
                      :disabled="isClose">
                <option v-for="choice in $options.gyneStageTypes(value.categoryId, value.conditionId)()"
                        :value="choice.id"
                        :key="choice.id">
                  {{ choice.name }}
                </option>
              </select>
            </p>
            <p v-if="value.conditionId === 999999">
              <input v-model="value.othersField"
                     placeholder="Specify histopath diagnosis"
                      :disabled="isClose" />
            </p>
            <smd-btn icon="smd-icon-action-delete"
                     @click="removeMultiSelectItem(key)"
                     v-if="!isClose"/>
          </div>
        </template>
      </template>

      <!--

      <div class="form__row--x">
        <label>Morbidities</label>
        <smd-wrapped-select v-model="gyneMorbiditiesModel"
                            multiSelectFormSection="gynemorbidities"
                            :multiSelectLookupName="$options.gyneMorbiditiesLookupName"
                            :multiSelectConditionsLookupName="$options.gyneMorbiditiesConditionsLookupName"
                            @open="onSelectMorbidityOpen"
                            @search-change="onSearchChange"/>
      </div>
      <div v-if="showMorbidities">
        <div class="data-entry" >
          <label>Category</label>
          <label>Condition</label>
        </div>

        <div class="data-entry" v-for="(value, key) in gynemorbidities" :key="key">
          <p><strong>{{ value.categoryId | decodeMorbidities }}</strong></p>
          <p>{{ key | decodeMorbidityCondition }}</p>
          <smd-btn icon="smd-icon-action-delete"
                   @click="removeMorbidityItem(key)"
                   v-if="!isClose"/>
        </div>

      </div>
      <div class="form__row--x">
        <label>Organ</label>
        <div class="form__row">
          <select v-model="gyneOrgan">
            <option v-for="mode in $options.organs()"
                    :value="mode.id"
                    :key="mode.id">
              {{ mode.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form__row--x">
        <label>Condition</label>
        <div class="form__row">
          <select v-model="organCondition">
            <option v-for="mode in organConditions"
                    :value="mode.id"
                    :key="mode.id">
              {{ mode.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form__row--x">
        <smd-segment type="pill"
                     v-model="gyneDiagnosis"
                     :items="$options.diagnosis"/>
      </div>

      <div class="form__row--x" v-if="gyneDiagnosis === 3">
        <label>Diagnosis</label>
        <div class="form__row">
          <select v-model="gtdDiagnosis">
            <option v-for="mode in $options.gtdDiagnosisList()"
                    :value="mode.id"
                    :key="mode.id">
              {{ mode.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form__row--x" v-if="gyneDiagnosis === 3">
        <label>Complications</label>
        <div class="form__row">
          <select v-model="gtdComplication">
            <option v-for="mode in $options.gtdComplications()"
                    :value="mode.id"
                    :key="mode.id">
              {{ mode.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form__row--x" v-show="willShowComplicationsOthers">
        <label>Surgical Intervention Others:</label>
        <input type="text" v-model="gtdComplicationOthers" placeholder="Others(specify)" />
      </div>

      <div class="form__row--x">
        <label>Medical/Surgical</label>
        <smd-segment type="pill"
                     v-model="medicalSurgical"
                     :items="$options.medicalSurgicals"/>
      </div>

      <div class="form__row--x" v-if="medicalSurgical === 2">
        <label>Intervention</label>
        <div class="form__row">
          <select v-model="surgicalIntervention">
            <option v-for="mode in $options.surgicalInterventions()"
                    :value="mode.id"
                    :key="mode.id">
              {{ mode.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form__row--x" v-show="willShowSurgicalInterventionOthers">
        <label>Surgical Intervention Others:</label>
        <input type="text" v-model="surgicalInterventionOthers" placeholder="Others(specify)" />
      </div>
      -->

    </div>

  </div>
</template>

<script>
  import caseFormMultiSelectMixin from './case-form-section-with-multiselect'
  import withSectionValidation from '../../../mixins/with-section-validation'
  import withErrorValidation from '../../../mixins/with-error-validation-mixin';
  import validations from '../../../validations/gyne-section-validation';
  import {getMapFn, REF_IN_SITU_CONDITION_ID, REF_MALIGNANT_CATEGORY_ID} from "../../../store/modules/referencedata2";
  import {
    ObjectModelToArrayModel
  } from '../../../utilities/utilityOperators'

  import {mapGetters, mapActions} from 'vuex'
  import {createHelpers} from 'vuex-map-fields'
  import {
    GETTER_CASE_FORM_STATE_FIELD,
    SETTER_CASE_FORM_STATE_FIELD,
    ACTION_UPDATE_GYNE_DIAGNOSIS,
    ACTION_UPDATE_GYNE_MORBIDITY,
    GETTER_GYNE_DIAGNOSIS,
    GETTER_GYNE_MORBIDITY,
    ACTION_REMOVE_CASE_MULTISELECT_ITEM
  } from '../../../store/forms/case-form-state'

  import {
    REF_MATERNAL_FETAL_FORM_GYNE,
    REF_MATERNAL_FETAL_FORM_GYNE_OBJ,
    REF_MATERNAL_FETAL_FORM_MORBIDITIES,
    REF_MATERNAL_FETAL_FORM_MORBIDITIES_CONDITIONS_OBJ,
    REF_MALIGNANT_STAGE_TYPES,
    REF_NONMALIGNANT_STAGE_TYPES
  } from '../../../store/modules/referencedata2'
  import SmdWrappedSelect from "./smd-wrapped-select";
  import {reduceModelFromKeys} from "../../../utilities/reduceFunctions";

  const {mapFields} = createHelpers({
    getterType: GETTER_CASE_FORM_STATE_FIELD,
    mutationType: SETTER_CASE_FORM_STATE_FIELD
  });

  export default{
    components: {SmdWrappedSelect},
    mixins: [caseFormMultiSelectMixin, withSectionValidation, withErrorValidation],
    computed: {
      ...mapGetters({
        gynecologicalDiagnosis: GETTER_GYNE_DIAGNOSIS,
        gynemorbidities       : GETTER_GYNE_MORBIDITY
      }),
      ...mapFields([
        'isGyne',
        'isPregnancy',
        'gynecologicalDiagnosis',
        'isClose'
      ]),
      gynecologicalDiagnosisModel: {
        get() {
          this.validateSection();
          return this.generateMultiSelectModel();
        },
        set(v) {
          const malignantCategories = getMapFn(REF_MALIGNANT_CATEGORY_ID)();
          const inSituConditions = getMapFn(REF_IN_SITU_CONDITION_ID)();
          const defaultFunc = (elem) => {
            const categoryId = elem["categoryId"];
            const conditionId = elem["conditionId"];
            if (inSituConditions.includes(conditionId)) {
              return {gyneStage: 6};
            } else if (malignantCategories.includes(categoryId)) {
              return {gyneStage: 1};
            } else {
              return {gyneStage: 6};
            }
          };
          const model = v.reduce(reduceModelFromKeys(defaultFunc)(this.gynecologicalDiagnosis),[]);
          this.doUpdateMultiSelectModel(model);
        }
      },
      gyneMorbiditiesModel: {
        get() {
          this.validateSection();
          const raw = this.gynemorbidities;
          const conditionsMapFn = getMapFn(this.$options.gyneMorbiditiesConditionsLookupName);
          return ObjectModelToArrayModel(raw, conditionsMapFn)
        },
        set(v) {
          const model = this.transformMultiSelectModel(v);
          this.doUpdateGyneMorbiditiesModel(model);
        }
      },
      sectionHeader() {
        return this.isPregnancy ? "Other Gynecological Conditions" : "Present Gynecological Conditions"
      },
      showDiagnosis() {
        return !!Object.keys(this.gynecologicalDiagnosis).length;
      },
      showMorbidities() {
        return !!Object.keys(this.gynemorbidities).length;
      }
    },
    methods: {
      ...mapActions({
        doUpdateMultiSelectModel: ACTION_UPDATE_GYNE_DIAGNOSIS,
        doUpdateGyneMorbiditiesModel: ACTION_UPDATE_GYNE_MORBIDITY,
        doRemoveMorbidity : ACTION_REMOVE_CASE_MULTISELECT_ITEM
      }),
      getRawModelForMultiSelect() {
        return this.gynecologicalDiagnosis;
      },
      removeMorbidityItem(key) {
        this.doRemoveMorbidity({section: 'gynemorbidities', conditionId: key});
      },
      onSelectOpen() {
        this.$emit('add');
      },
      onSelectMorbidityOpen() {
        this.$emit('addComorbidity')
      },
      onSearchChange(q) {
        this.$emit('search-change', q);
      }
    },
    gyneStageTypes: function(categoryId, conditionId) {
      const malignantCategories = getMapFn(REF_MALIGNANT_CATEGORY_ID)();
      const inSituConditions = getMapFn(REF_IN_SITU_CONDITION_ID)();
      if (inSituConditions.includes(conditionId)) {
        return () => [{ id: 6, name: 'N/A' }];
      }
      if (malignantCategories.includes(categoryId)) {
        return getMapFn(REF_MALIGNANT_STAGE_TYPES);
      }
      return getMapFn(REF_NONMALIGNANT_STAGE_TYPES);
    },
    booleanChoices: [
      {id: 1, name: 'YES', val: true},
      {id: 2, name: 'NO', val: false}
    ],
    validationSection: 'gyne',
    multiSelectLookupName: REF_MATERNAL_FETAL_FORM_GYNE,
    multiSelectConditionsLookupName: REF_MATERNAL_FETAL_FORM_GYNE_OBJ,
    gyneMorbiditiesLookupName: REF_MATERNAL_FETAL_FORM_MORBIDITIES,
    gyneMorbiditiesConditionsLookupName: REF_MATERNAL_FETAL_FORM_MORBIDITIES_CONDITIONS_OBJ,
    multiSelectFormSection: 'gynecologicalDiagnosis',
    validations
  }
</script>

<style lang="scss" scoped>
  @import "../../../scaffolding/scss/pogs-util";

  .data-entry-3 {
    @media (max-width: 768px) {
      grid-template-columns: 60px 75px 1fr auto;
    }
    select {
      width: 100%;
      min-width: 80px;
    }
  }
</style>
